import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Home, BarChart3, ArrowLeft, Sparkles } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

const NotFound = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50 flex items-center justify-center px-4">
      {/* Background decoration */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-emerald-100 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse"></div>
        <div className="absolute top-40 right-10 w-72 h-72 bg-teal-100 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse animation-delay-2000"></div>
        <div className="absolute -bottom-8 left-20 w-72 h-72 bg-green-100 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse animation-delay-4000"></div>
      </div>

      <div className="max-w-md w-full relative z-10">
        <Card className="border-0 shadow-xl bg-white/80 backdrop-blur-sm">
          <CardContent className="p-8 text-center">
            {/* Logo */}
            <div className="mb-8">
              <div className="text-3xl font-bold text-gray-900 hover:scale-105 transition-all duration-300 cursor-pointer group">
                Kauf<span className="bg-gradient-to-r from-emerald-500 via-emerald-600 to-emerald-700 bg-clip-text text-transparent group-hover:from-emerald-400 group-hover:via-emerald-500 group-hover:to-emerald-600 transition-all duration-300">Pause</span>
              </div>
            </div>

            {/* 404 Icon */}
            <div className="w-24 h-24 bg-gradient-to-br from-emerald-100 to-emerald-200 rounded-full flex items-center justify-center mx-auto mb-6">
              <span className="text-4xl font-bold text-emerald-600">404</span>
            </div>

            {/* Heading */}
            <h1 className="text-2xl font-bold text-gray-900 mb-3">
              Seite nicht gefunden
            </h1>

            {/* Description */}
            <p className="text-gray-600 mb-8 leading-relaxed">
              Die Seite, die du suchst, existiert nicht oder wurde verschoben. 
              Kein Problem - lass uns dich zurück zum bewussten Konsumieren bringen!
            </p>

            {/* Action Buttons */}
            <div className="space-y-3">
              {user ? (
                <>
                  <Button 
                    onClick={() => navigate('/dashboard')}
                    className="w-full bg-gradient-to-r from-emerald-600 to-emerald-700 hover:from-emerald-700 hover:to-emerald-800 text-white shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 group"
                  >
                    <BarChart3 className="w-4 h-4 mr-2 group-hover:scale-110 transition-transform duration-300" />
                    Zum Dashboard
                  </Button>
                  <Button 
                    variant="outline"
                    onClick={() => navigate('/')}
                    className="w-full border-emerald-600 text-emerald-600 hover:bg-emerald-50 transition-all duration-300"
                  >
                    <Home className="w-4 h-4 mr-2" />
                    Zur Startseite
                  </Button>
                </>
              ) : (
                <>
                  <Button 
                    onClick={() => navigate('/')}
                    className="w-full bg-gradient-to-r from-emerald-600 to-emerald-700 hover:from-emerald-700 hover:to-emerald-800 text-white shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 group"
                  >
                    <Home className="w-4 h-4 mr-2 group-hover:scale-110 transition-transform duration-300" />
                    Zur Startseite
                  </Button>
                  <Button 
                    variant="outline"
                    onClick={() => navigate(-1)}
                    className="w-full border-emerald-600 text-emerald-600 hover:bg-emerald-50 transition-all duration-300"
                  >
                    <ArrowLeft className="w-4 h-4 mr-2" />
                    Zurück
                  </Button>
                </>
              )}
            </div>

            {/* Small feature hint */}
            <div className="mt-8 p-3 bg-emerald-50 rounded-lg">
              <div className="flex items-center justify-center gap-2 text-emerald-700">
                <Sparkles className="w-4 h-4" />
                <span className="text-sm font-medium">
                  30 Tage Bedenkzeit für bewusste Kaufentscheidungen
                </span>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default NotFound;
